import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button, Empty, Space, List } from "antd";

import moment from "moment";
import { chain, filter } from "lodash";
import { ReloadOutlined } from "@ant-design/icons";
import LoadingPage from "../../components/LoadingPage";

import PickerWithType from "../../libs/components/PickerWithType";
import SelectDateType from "../../libs/components/SelectDateType";
import { GetDateRange } from "../../libs/utils";

function OfflineRobots(props) {
  const robots = useSelector((state) => state.robot.robots);

  const [dateValues, setDateValues] = useState(null);
  const [type, setType] = useState("range");

  const today = moment();
  const lastWeek = moment().subtract(7, "days");

  if (!robots) {
    return <LoadingPage></LoadingPage>;
  }

  const robotDate = robots.map((item) => {
    return {
      unit: item.name,
      date: (item.summary && item.summary.date) || null,
    };
  });

  const inActiveRobots = filter(robotDate, (item) => {
    const start =
      dateValues && dateValues.length > 0
        ? dateValues[0]
        : lastWeek.format("YYYY-MM-DD");
    const end =
      dateValues && dateValues.length > 0
        ? dateValues[1]
        : today.format("YYYY-MM-DD");

    return moment(item.date).isBetween(start, end, undefined, "[]");
  });

  const inActiveRobotsData = chain([...inActiveRobots])
    .uniqBy("date")
    .orderBy(({ date }) => date || "", "asc")
    .map((item) => {
      const filteredRobots = filter([...inActiveRobots], (i) => {
        return i.date === item.date;
      });
      return {
        date: item.date,
        robots: filteredRobots,
        value: filteredRobots.length,
      };
    })
    .value();

  return (
    <>
      <Space>
        <b>Last online date</b>
        <br></br>
        <SelectDateType value={type} onChange={setType}></SelectDateType>
        <PickerWithType
          type={type}
          defaultValue={[lastWeek, today]}
          onChange={(value) => setDateValues(value)}
        />
        <Button
          disabled={!dateValues}
          onClick={() => {
            const dateRange = GetDateRange(type, dateValues);
            setDateValues(dateRange);
          }}
          icon={<ReloadOutlined />}
        ></Button>
      </Space>
      <br></br>

      <div>
        {!inActiveRobotsData || inActiveRobotsData.length === 0 ? (
          <Empty />
        ) : (
          <List
            style={{ height: 300, overflowY: "scroll" }}
            itemLayout="horizontal"
            dataSource={inActiveRobotsData}
            size="small"
            renderItem={(item) => (
              <List.Item key={item.date} title={item.date}>
                {item.robots.map((i) => (
                  <List.Item.Meta
                    title={item.date}
                    description={i.unit === 1 ? 171 : i.unit}
                  ></List.Item.Meta>
                ))}
              </List.Item>
            )}
          />
        )}
      </div>
    </>
  );
}
export default OfflineRobots;
